/**
 * @file 异常页面组件
 * @author mengchen <sisimengchen@gmail.com>
 */
import React from 'react';
import config from './config';
import bbtNative from '@bbtfe/native';
import './index.scss';

const CoreException = ({
  type = '404',
  title,
  desc,
  img,
  onBtnClick,
  btnText = '',
  ...rest
}) => (
  <div id="core-exception" {...rest}>
    <div className="image-block">
      <img src={img || config[type].img} />
    </div>
    <div className="content-block">
      <h1>{title || config[type].title}</h1>
      <div className="desc">{desc || config[type].desc}</div>
      {onBtnClick ? (
        <span
          className="btn"
          onClick={() => {
            onBtnClick();
          }}
        >
          {btnText || '我知道了'}
        </span>
      ) : (
        bbtNative.isApp() ?
          (<a className="btn" onClick={()=>{
              window.location.reload();
          }}>
              点我重试
          </a>):
          (<a
              className="btn"
              href="https://popen.babytree.com/pregnancy/index.html?middlePage=1&loadurl=https%3A%2F%2Fwebview.babytree.com%2Fpreg_web%2Ffe%2Findex%3Ffe_path%3Dtmpl%2Ffe_tool%2Fcaneat%2Fdist%2Fpages%2FIndex%2FIndex%26forbid_scroll%3Dtrue%26navigation_bar_hidden%3Dtrue&refcode=m_y_share_gj_nbnc_20200210&downloadUrl=http%3A%2F%2Fr.babytree.com%2FfPJ7wGt"
          >
              立即下载
          </a>)
      )}
    </div>
  </div>
);
export default CoreException;
